// Cliente da API (contrato em src/compartilhado/api.ts): { data, error }, X-CSRF em toda escrita,
// 401 "sessao" leva ao login Microsoft (/auth/entrar).

import type { EuDTO } from '../compartilhado/api.js';
import { lsGet, lsSet } from './util.js';

export class ErroApi extends Error {
  status: number;
  constructor(msg: string, status: number) { super(msg); this.status = status; }
}

let csrf = '';
export let eu: EuDTO | null = null;

export function irParaLogin() {
  const volta = location.pathname + location.search + location.hash;
  location.href = '/auth/entrar?volta=' + encodeURIComponent(volta || '/');
}

export interface OpcoesApi { silencioso?: boolean }

export async function api<T = any>(metodo: string, caminho: string, corpo?: any, op?: OpcoesApi): Promise<T> {
  const h: Record<string, string> = {};
  if (metodo !== 'GET') h['X-CSRF'] = csrf;
  let body: any;
  if (corpo instanceof FormData) body = corpo;
  else if (corpo !== undefined) { h['Content-Type'] = 'application/json'; body = JSON.stringify(corpo); }
  const r = await fetch(caminho, { method: metodo, headers: h, body, credentials: 'same-origin', cache: 'no-store' });
  let j: any = null;
  try { j = await r.json(); } catch { j = null; }
  if (r.status === 401) {
    if (!op?.silencioso) irParaLogin();
    throw new ErroApi('sessao', 401);
  }
  if (!r.ok || (j && j.error)) throw new ErroApi((j && j.error) || ('HTTP ' + r.status), r.status);
  return (j ? j.data : null) as T;
}

/** Sessão atual. Guarda uma cópia (sem o csrf) para abrir a tela inicial sem rede. */
export async function carregarEu(op?: OpcoesApi): Promise<EuDTO> {
  const d = await api<EuDTO>('GET', '/api/eu', undefined, op);
  eu = d;
  csrf = d.csrf;
  const { csrf: _c, ...copia } = d;
  lsSet('cache_eu', copia);
  return d;
}

/** Última sessão conhecida, para o uso offline (cache, nunca fonte de verdade). */
export function euEmCache(): EuDTO | null {
  return eu || lsGet('cache_eu');
}

/** GET com cópia local para o uso offline (cadastro e checklist). */
export async function getComCache<T>(caminho: string, chave: string): Promise<T> {
  try {
    const d = await api<T>('GET', caminho);
    lsSet('cache_' + chave, d);
    return d;
  } catch (e: any) {
    if (e instanceof ErroApi && e.status === 401) throw e;
    const c = lsGet('cache_' + chave);
    if (c) return c as T;
    throw e;
  }
}
